export default __webpack_public_path__ + "static/media/14.3d8f9ed5.jpg";